import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {COACH} from '/enum/competency.enum';
import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import RefreshInfoPopover from './RefreshInfoPopover';

const withCurrentUserCoachId = withProps({coachId: userId});

export const RefreshInfoPopoverConnect = connect(
  createStructuredSelector({
    competency: withCurrentUserCoachId(competencyById),
  }),
  {},
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    isCoach: stateProps.competency === COACH,
  }),
)(RefreshInfoPopover);
